const s3ImageLoader = (src: string) => {
  if (src.startsWith('http')) return src

  return `${import.meta.env.VITE_STATIC_ENDPOINT}/${src}`
}

interface ImageFromBucketProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

const ImageFromBucket: React.FC<ImageFromBucketProps> = ({
  src,
  alt,
  ...props
}) => {
  const imageUrl = s3ImageLoader(src)

  return <img src={imageUrl} alt={alt} {...props} />
}

export default ImageFromBucket
